import { render, staticRenderFns } from "./CoreSkillTab.vue?vue&type=template&id=0c6ca697&"
import script from "./CoreSkillTab.vue?vue&type=script&lang=js&"
export * from "./CoreSkillTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports